module.exports = "pegasus/assets/circleline-tumblr.png";